module.exports = __webpack_public_path__ + "static/media/arrow-down-up.416d93fc.svg";